import { gql } from "@apollo/client";

export const ADD_MASSIVE_INSTANCIA_CREDITICIA = gql`
    mutation addMassiveInstanciaCrediticia(
        $idEstado: Int!
        $idEvaluaciones: [Int!]!
        $idMotivo: Int
        $motivo: String
    ){
        addMassiveInstanciaCrediticia(input:{
            idEstado: $idEstado
            idEvaluaciones: $idEvaluaciones
            idMotivo: $idMotivo
            motivo: $motivo
        }){
            success,
            error,
            valorEsperado
        }
    }
`;